module.exports = __webpack_public_path__ + "img/PPGestor-portal.e7a6d27a.png";